import { formatDate } from '@/helpers/date'
import { Model } from '@/models'
import { GlobalReportService } from '@/services'

export class GlobalReport extends Model {
    /**
     * Create a GlobalReport model wrapper.
     * @param {Object} data - Object holding the field values.
     */
    constructor (data) {
        super()
        Model.initializeFields(this, [
            'id',
            'type',
            'metadata',
            'data',
            'report_date',
        ], data)
    }

    static get service () { return GlobalReportService }

    get formattedReportDate () {
        return (this.report_date) ? formatDate(this.report_date) : undefined
    }
}
